module.exports = __webpack_public_path__ + "static/media/tele724-logo.ab5b1402.png";